import { action, observable } from 'mobx';
import { accountApi } from '@link/skytree/services';
import { Account as AccountType } from '@link/skytree/services/types';
import { setUserId } from '@link/skytree/vendors/ga';

export class Account {
  @observable accessor accountInfo: AccountType = {};

  getAccountInfo() {
    return accountApi.getAccount().then(res => {
      const account = res.account ?? ({} as AccountType);
      this.setAccountInfo(account);
      return account;
    });
  }

  @action
  setAccountInfo(account: AccountType) {
    this.accountInfo = account;
    if (account.id) {
      setUserId(account.id);
    }
  }

  submitAccountInfo(account: AccountType) {
    return accountApi
      .updateAccount({
        body: {
          account
        }
      })
      .then(res => {
        const updatedAccount = res.account ?? account;
        this.setAccountInfo(updatedAccount);
        return res;
      });
  }
}

export default new Account();
